import React, { Component } from 'react'
import { MOBILE } from '../../constants'
import Player from '../player/Player'
import TouchPlayer from '../player/TouchPlayer'
import VideoLoop from '../video/VideoLoop'
import Fullscreen from '../fullscreen/Fullscreen'
import classnames from 'classnames'

class MediaAsset extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isComplete: false,
      isError: false
    }

    this.loadEvent = new Event('loadmedia')
  }

  componentDidMount() {
    if (this.imageEl && this.imageEl.complete && !this.state.isComplete) {
      this.onImageLoad()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { vh } = this.props 

    const {
      offsetTop: nextOffsetTop,
    } = nextProps
    const {
      offsetTop: prevOffsetTop,
    } = this.props

    if (nextOffsetTop !== prevOffsetTop) {
      // FIXME: this is never used
      if (nextOffsetTop < vh && nextOffsetTop > 0) {
        this.setState({ inViewport: true })
      } else {
        this.setState({ inViewport: false })
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.src !== this.props.src) return true
    if (nextProps.active !== this.props.active) return true
    if (nextProps.videoSrc !== this.props.videoSrc) return true
    if (nextState.isComplete !== this.state.isComplete) return true
    if (nextState.willPlayVideo !== this.state.willPlayVideo) return true
    if (nextState.inViewport !== this.state.inViewport) return true
    return false
  }

  onFullscreenChange() {
  }

  onImageLoad = () => {
    this.setState({
      isComplete: true
    })

    window.dispatchEvent(this.loadEvent)
  }

  onImageError = () => {
    this.setState({
      isComplete: true,
      isError: true
    })
  }

  renderImage() {
    const { style, classNames, inViewport, index, offsetTop, videoPosterSrc, videoControls, videoActive, videoSrc, videoWidth, videoHeight, ...otherProps } = this.props
    const { isComplete } = this.state
    
    const src = ( videoSrc && videoPosterSrc ) || this.props.src

    const imageClassNames = classnames({
      'media-image--complete': isComplete
    }, 'media-image')
    
    delete otherProps.active
    delete otherProps.usePlayer
    
    return (
      <img 
        ref={el => this.imageEl = el}
        style={style}
        className={`${imageClassNames} ${classNames}`}
        {...otherProps}
        src={ src }
        alt={''}
        onLoad={this.onImageLoad}
        onError={this.onImageError}
      />
    )
  }
  
  renderLoop() {
    return (
      <VideoLoop 
        active={ this.props.active }
        src={ this.props.videoSrc } 
        muted
        poster={  this.props.videoPosterSrc } 
        width={ this.props.videoWidth }
        height={ this.props.videoHeight }
        style={ this.props.mediaStyle }
      />
    )
  }

  renderVideo() {
    const { 
      style: mediaStyle, 
      videoSrc, 
      videoPosterSrc,
      videoWidth, 
      videoHeight } = this.props 

    return MOBILE 
    ? (
      <TouchPlayer
        src={videoSrc}
        active={this.props.active}
        poster={videoPosterSrc}
        style={mediaStyle}
        width={videoWidth}
        height={videoHeight}
      />
    )
    :  (
      <Fullscreen onFullscreenChange={this.onFullscreenChange}>
        <Player
          src={videoSrc}
          active={this.props.active}
          poster={videoPosterSrc}
          style={mediaStyle}
          startTime={0}
          width={videoWidth}
          height={videoHeight}
          controls={true}
          preload="always"
        />
      </Fullscreen>
    )
  }

  render() {
    const { videoSrc } = this.props
    
    if ( this.props.usePlayer ) {
      return this.renderVideo()
    } 
    else if ( videoSrc ) {
      return this.renderLoop()
    }
    
    return this.renderImage()
  }
}

export default MediaAsset



// WEBPACK FOOTER //
// ./src/components/media-asset/index.js